import { GRANTS } from '@/other/constants/PrivilegeTypes';
import { INCENTIVE_PERMISSION_KEYS } from '@/other/constants/IncentiveKeys';
import { checkIncentivePermission } from '@/other/utils/incentiveUtils';

export const canCopyRecord = (isEnabled: boolean, selectedBoard: any, boardStore: any) => (
  isEnabled && boardStore.records.some((board: any) => (
    board.id !== selectedBoard.id && board.grants?.includes(GRANTS.grant_four)
  ))
)

/**
 * Check if user can archive/unarchive a record
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const canArchive = (user: any, record: any): boolean => {
  if (!user || !record) return false;
  const result = user.can(GRANTS.grant_three);
  return !record.isPhantom && Boolean(result);
};

/**
 * Check if user can delete a record (only when archived)
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const canDelete = (user: any, record: any): boolean => {
  if (!user || !record) return false;
  const result = user.can(GRANTS.grant_three);
  return !record.isPhantom && Boolean(record.archived) && Boolean(result);
};

/**
 * Check if user can share a record
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const canShare = (user: any, isDemoUser: boolean, record: any): boolean => {
  if (!user || !record) return false;
  return !record.isPhantom && !isDemoUser;
};

/**
 * Check if user can copy record to other boards
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const canCopyToBoard = (user: any, isDemoUser: boolean, selectedBoard: any, boardStore: any): boolean => {
  if (!user || isDemoUser) return false;
  const result = canCopyRecord(!isDemoUser, selectedBoard, boardStore);
  return Boolean(result);
};

/**
 * Check if user can export history
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const canExportHistory = (user: any, record: any): boolean => {
  if (!user || !record) return false;
  return !record.isPhantom && user.can(GRANTS.grant_one);
};

/**
 * Check if user can adjust points
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const canAdjustPoints = (user: any, project: any, record: any): boolean => {
  if (!user || !record || !project) return false;
  return (
    !record.isPhantom &&
    checkIncentivePermission({
      project,
      permissionKey: INCENTIVE_PERMISSION_KEYS.INCENTIVE_MANAGERS,
    })
  );
};
